import * as React from 'react'

import { useTrans } from '~logic/i18n/useTrans'
import { IconLine } from '~ui/components/IconLine/IconLine'
import { IconInfo } from '~ui/components/icons/specific/IconInfo'
import { Box } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'
import { defaultLineHeight, getTextFontSizeInPx, TTextFontSize } from '~ui/styleGuide/fontStyles'

import { useCartContentCtx } from '../contexts/CartContentProvider'
import { validateOrderPrice } from '../helpers/validateCartContent'

type TProps = NoChildren & {
  justifySelf?: PropsOf<typeof Box>['justifySelf']
  transportFeeMessage?: Nullable<React.ReactElement>
}

const fontSize: TTextFontSize = `m16`

/**
 * Renders a message with formatted value of the `minimalOrderPrice`.
 * The whole content is centered when rendered inside a grid/flex container.
 */
export const OrderPriceMessage: React.FC<TProps> = ({
  transportFeeMessage,
  justifySelf = `center`,
}) => {
  const order = useCartContentCtx()
  const { trans } = useTrans()

  const { minimalPriceMessage } = validateOrderPrice(order)

  const message = minimalPriceMessage ? trans(minimalPriceMessage) : transportFeeMessage

  if (!message) {
    return null
  }

  return (
    <Box justifySelf={justifySelf}>
      <IconLine
        icon={IconInfo}
        spacing={`small`}
        iconSize={`1.1rem`}
        iconAlign={`flex-start`}
        iconPartForcedHeight={`calc(${getTextFontSizeInPx(fontSize)}px * ${defaultLineHeight})`}
      >
        <Text fontSize={fontSize}>{message}</Text>
      </IconLine>
    </Box>
  )
}
